import React from 'react';
import { VaAccordion } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';
import { getAccessVALinks } from './AccessVALinks';
import './accessva-tools-widget.scss';

export function AccessVAToolsWidget() {
  const { useToggleValue, useToggleLoadingValue, TOGGLE_NAMES } = useFeatureToggle();
  
  // Get all AccessVA feature toggle values
  const featureToggles = {
    accessVaBoxHighImpactOktaurl: useToggleValue(TOGGLE_NAMES.accessVaBoxHighImpactOktaurl),
    accessVaBoxOktaurl: useToggleValue(TOGGLE_NAMES.accessVaBoxOktaurl),
    accessVaCcraOktaurl: useToggleValue(TOGGLE_NAMES.accessVaCcraOktaurl),
    accessVaCentralizedMailOktaurl: useToggleValue(TOGGLE_NAMES.accessVaCentralizedMailOktaurl),
    accessVaEdeliveryOktaurl: useToggleValue(TOGGLE_NAMES.accessVaEdeliveryOktaurl),
    accessVaEdmsOktaurl: useToggleValue(TOGGLE_NAMES.accessVaEdmsOktaurl),
    accessVaFastOktaurl: useToggleValue(TOGGLE_NAMES.accessVaFastOktaurl),
    accessVaGrants4vetsOktaurl: useToggleValue(TOGGLE_NAMES.accessVaGrants4vetsOktaurl),
    accessVaHmisOktaurl: useToggleValue(TOGGLE_NAMES.accessVaHmisOktaurl),
    accessVaIamInvitationOktaurl: useToggleValue(TOGGLE_NAMES.accessVaIamInvitationOktaurl),
    accessVaKahuaOktaurl: useToggleValue(TOGGLE_NAMES.accessVaKahuaOktaurl),
    accessVaLifeInsuranceOktaurl: useToggleValue(TOGGLE_NAMES.accessVaLifeInsuranceOktaurl),
    accessVaMceqVendorPortalOktaurl: useToggleValue(TOGGLE_NAMES.accessVaMceqVendorPortalOktaurl),
    accessVaMoveliqApprovalOktaurl: useToggleValue(TOGGLE_NAMES.accessVaMoveliqApprovalOktaurl),
    accessVaMoveliqEmployeeOktaurl: useToggleValue(TOGGLE_NAMES.accessVaMoveliqEmployeeOktaurl),
    accessVaMoveliqExpenseOktaurl: useToggleValue(TOGGLE_NAMES.accessVaMoveliqExpenseOktaurl),
    accessVaMvpOktaurl: useToggleValue(TOGGLE_NAMES.accessVaMvpOktaurl),
    accessVaPawsOktaurl: useToggleValue(TOGGLE_NAMES.accessVaPawsOktaurl),
    accessVaProstheticsVendorOktaurl: useToggleValue(TOGGLE_NAMES.accessVaProstheticsVendorOktaurl),
    accessVaQgendaOktaurl: useToggleValue(TOGGLE_NAMES.accessVaQgendaOktaurl),
    accessVaQuicksubmitOktaurl: useToggleValue(TOGGLE_NAMES.accessVaQuicksubmitOktaurl),
    accessVaRoesOktaurl: useToggleValue(TOGGLE_NAMES.accessVaRoesOktaurl),
    accessVaSourcetrackOktaurl: useToggleValue(TOGGLE_NAMES.accessVaSourcetrackOktaurl),
    accessVaSports4vetsOfficialsOktaurl: useToggleValue(TOGGLE_NAMES.accessVaSports4vetsOfficialsOktaurl),
    accessVaSports4vetsOktaurl: useToggleValue(TOGGLE_NAMES.accessVaSports4vetsOktaurl),
    accessVaSquaresOktaurl: useToggleValue(TOGGLE_NAMES.accessVaSquaresOktaurl),
    accessVaVaCaregiverSupportOktaurl: useToggleValue(TOGGLE_NAMES.accessVaVaCaregiverSupportOktaurl),
    accessVaValerirOktaurl: useToggleValue(TOGGLE_NAMES.accessVaValerirOktaurl),
    accessVaValifeOktaurl: useToggleValue(TOGGLE_NAMES.accessVaValifeOktaurl),
    accessVaVetbizOktaurl: useToggleValue(TOGGLE_NAMES.accessVaVetbizOktaurl),
    accessVaVetHomeOktaurl: useToggleValue(TOGGLE_NAMES.accessVaVetHomeOktaurl),
    accessVaVeteranTravelClaimOktaurl: useToggleValue(TOGGLE_NAMES.accessVaVeteranTravelClaimOktaurl),
    accessVaVeteransHealthVentureStudioOktaurl: useToggleValue(TOGGLE_NAMES.accessVaVeteransHealthVentureStudioOktaurl),
    accessVaVetrideOktaurl: useToggleValue(TOGGLE_NAMES.accessVaVetrideOktaurl),
    accessVaVhicOktaurl: useToggleValue(TOGGLE_NAMES.accessVaVhicOktaurl),
    accessVaVicOktaurl: useToggleValue(TOGGLE_NAMES.accessVaVicOktaurl),
    accessVaVlogicfmOktaurl: useToggleValue(TOGGLE_NAMES.accessVaVlogicfmOktaurl),
    accessVaVtaIdesOktaurl: useToggleValue(TOGGLE_NAMES.accessVaVtaIdesOktaurl),
    accessVaYouritOktaurl: useToggleValue(TOGGLE_NAMES.accessVaYouritOktaurl),
  };
  
  // Check if feature toggles are still loading (per guide recommendation)
  const isLoadingToggles = useToggleLoadingValue();
  
  // Get environment-appropriate links with feature toggle overrides applied
  const accessVALinks = getAccessVALinks(featureToggles);
  
  // Show loading indicator while feature toggles are being fetched
  if (isLoadingToggles) {
    return (
      <div className="accessva-tools-widget">
        <va-loading-indicator message="Loading AccessVA tools..." />
      </div>
    );
  }
  
  return (
    <div className="accessva-tools-widget">
      {/* Accordion */}
      <VaAccordion>
        <va-accordion-item
          header="Veterans, family members, and service members"
          id="veterans-accordion"
        >
          <ul className="usa-list">
            {accessVALinks.veterans.map((link, index) => (
              <li key={index}>
                {link.urls && Array.isArray(link.urls) ? (
                  <>
                    {link.text}
                    {link.urls.map((urlObj, urlIndex) => (
                      <React.Fragment key={urlIndex}>
                        {' '}
                        <a href={urlObj.url} className="vads-u-color--link-default">
                          {urlObj.label}
                        </a>
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <a href={link.url} className="vads-u-color--link-default">
                    {link.text}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </va-accordion-item>

        <va-accordion-item
          header="Business partners, employees, and contractors"
          id="business-accordion"
        >
          <ul className="usa-list">
            {accessVALinks.business.map((link, index) => (
              <li key={index}>
                {link.urls && Array.isArray(link.urls) ? (
                  <>
                    {link.text}
                    {link.urls.map((urlObj, urlIndex) => (
                      <React.Fragment key={urlIndex}>
                        {' '}
                        <a href={urlObj.url} className="vads-u-color--link-default">
                          {urlObj.label}
                        </a>
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <a href={link.url} className="vads-u-color--link-default">
                    {link.text}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </va-accordion-item>
      </VaAccordion>
    </div>
  );
}

export default AccessVAToolsWidget;
